import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import LifestylePrizesPage from "../app/(custom-header)/prizes/lifestyle/page";

const root = createRoot(document.getElementById("lifestyle-page") as HTMLElement);

root.render(
  <StoreProvider>
    <LifestylePrizesPage />
  </StoreProvider>
);
